import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
import * as React from 'react';
import Label from '../../../../typography/Label';
import FormGroupInline from '../../../../forms/FormGroupInline/FormGroupInline';
import Input from '../../../../inputs/Input';
import RangeFloatingFilter from './RangeFloatingFilter';

var DateFloatingFilter =
/*#__PURE__*/
function (_RangeFloatingFilter) {
  _inherits(DateFloatingFilter, _RangeFloatingFilter);

  function DateFloatingFilter(props) {
    _classCallCheck(this, DateFloatingFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(DateFloatingFilter).call(this, props));
  }
  /**
   * Renders floating date filter component
   */


  _createClass(DateFloatingFilter, [{
    key: "render",
    value: function render() {
      return React.createElement(FormGroupInline, {
        right: false
      }, React.createElement(Input, {
        type: "text",
        tiny: true,
        name: "from",
        placeholder: "yyyy-mm-dd",
        value: this.state.from,
        onChange: this.onChange
      }), React.createElement(Label, null, "-"), React.createElement(Input, {
        type: "text",
        tiny: true,
        name: "to",
        placeholder: "yyyy-mm-dd",
        value: this.state.to,
        onChange: this.onChange
      }));
    }
  }]);

  return DateFloatingFilter;
}(RangeFloatingFilter);

export { DateFloatingFilter as default };